import { Avatar } from '@material-ui/core'
import React, {useState, useEffect} from 'react'
import './Sidebar.css'
// import DonutLargeIcon from '@material-ui/icons/DonutLarge';
import DonutLargeRoundedIcon from '@material-ui/icons/DonutLargeRounded';
import ChatIcon from '@material-ui/icons//Chat';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import SearchIcon from '@material-ui/icons/Search';
import SingleMessage from '../SingleMessage'
import WifiOffIcon from '@material-ui/icons/WifiOff';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import EmojiEmotionsOutlinedIcon from '@material-ui/icons/EmojiEmotionsOutlined';
import DoneOutlinedIcon from '@material-ui/icons/DoneOutlined';
import { Offline, Online } from "react-detect-offline";
import { motion, AnimatePresence } from "framer-motion"
import { useStore } from '../../StateManagement';
import {storage, db} from '../../Firebase/firebase'
import NewGroupParticipantSelection from "../NewGroupParticipantSelection"
import CreateGroupInfo from '../CreateGroupInfo'
import SidebarFrame from './reusable/SidebarFrame';
import Settings from './elements/Settings';

function Sidebar() {
  const [showMenu, setShowMenu] = useState(false);
  const [showParticipantMenu, setShowParticipantMenu] = useState(false);
  const [showCreateGroupInfo, setShowCreateGroupInfo] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [stateData, dispatch] = useStore();
  const [allUsersInDatabase, setAllUsersInDatabase] = useState([]);
  const [newSelectedMembers, setNewSelectedMembers] = useState([]);
  // const [searchResult, setSearchResult] = useState(allUsersInDatabase);
  const [searchWord, setSearchWord] = useState('');
  const [messages, setMessages] = useState([])

  useEffect(()=>{
    db.collection('users').onSnapshot((snapshot)=>{
      setAllUsersInDatabase(snapshot.docs.map((doc)=> ({id: doc.id, ...doc.data()})))
    })
  }, [])

  useEffect(()=>{
    db.collection('groups').onSnapshot((snapshot)=>{
      setMessages(snapshot.docs.map((doc)=> ({id: doc.id, ...doc.data()})))
    })
  }, [])

  // functions
  const handleLogOut = () => {
    dispatch({
      type: 'LOG_OUT'
    })
  }

  const resetSidebar = () => {
    setShowCreateGroupInfo(false)
    setShowParticipantMenu(false)
    setShowMenu(false)
    setShowSettings(false)
  }

  return (
      <AnimatePresence>
        <div className="sidebar">
          <div className="sidebar__container">
            <div className="sidebar__header">
            <Avatar src={stateData.userDetails.profilePhotoUrl} />
            <div className="icons">
              <span>
                <DonutLargeRoundedIcon />
              </span>
              <span>
                <ChatIcon />
              </span>
              <span 
                style={{
                  backgroundColor: showMenu &&"#D5D5D5"
                }} 
                onClick={()=> setShowMenu(!showMenu)}
              >
                <MoreVertIcon />
              </span>
              <AnimatePresence>
                {showMenu && 
                  <motion.div
                    key="menu"
                    animate={{
                      width: [100, 196],
                      height: [80, 180],
                      opacity: [0, 1]
                    }}
                    transition={{ duration: 0.5 }}
                    initial={{
                      width: 100,
                      height: 80,
                      opacity: 0
                    }}
                    exit={{
                      width: 100,
                      height: 80,
                      opacity: 0
                    }}          
                    className="menu__card"
                  >
                  <p onClick={()=> {
                    resetSidebar()
                    setShowParticipantMenu(true)
                  }}>New group</p>
                  <p>Starred</p>
                  <p onClick={()=> {
                    resetSidebar()
                    setShowSettings(true)
                  }}>Settings</p>
                  <p onClick={handleLogOut}>Log out</p>
                </motion.div>
                }
              </AnimatePresence>
            </div>
          </div>
          <Offline>
            <div className="sidebar__network__indicator">
              <div className="sidebar__network__indicator__container">
                <div className="network__icon">
                  <WifiOffIcon />
                </div>
                <div className="network__info">
                  <h2>Phone not connected</h2>
                  <p>Make sure your phone has an active internet connection. <br /> Learn more <KeyboardArrowRightIcon /></p>
                </div>
              </div>
            </div>
          </Offline>
          <div className="sidebar__search">
            <div className="sidebar__search__container">
              <SearchIcon />
              <input type="text" placeholder="Search or start new chat" />                       
            </div>
          </div>
          <div className="sidebar__messages">
            {messages.map(message => 
              <SingleMessage 
                key={message.id}
                name={message.groupName} 
                message={message.lastMessage ? message.lastMessage : 'New chat !!!'}
                imageUrl={message.groupPhotoUrl} 
                lastPerson={message.lastPerson}
                id={message.id}
                read={true}
              />
            )}
          </div>
          <AnimatePresence>
            {/* settings */}
            { showSettings 
              && 
              <SidebarFrame title="settings" hide={resetSidebar}>
                <Settings />
              </SidebarFrame>
            }

            {showParticipantMenu && 
              <NewGroupParticipantSelection 
                newSelectedMembers={newSelectedMembers} 
                setNewSelectedMembers={setNewSelectedMembers} 
                setShowCreateGroupInfo={setShowCreateGroupInfo}
                setShowParticipantMenu={setShowParticipantMenu} 
                allUsersInDatabase={allUsersInDatabase}
                setAllUsersInDatabase={setAllUsersInDatabase}
                /> 
              }
            {showCreateGroupInfo && 
              <CreateGroupInfo
                setShowCreateGroupInfo={setShowCreateGroupInfo}
                newSelectedMembers={newSelectedMembers}
                setShowParticipantMenu={setShowParticipantMenu}
               />
            }
          </AnimatePresence>
        </div>
      </div>
      </AnimatePresence>
  )
}

export default Sidebar
